import { useContext, useEffect } from 'react';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { Container, Description, Suggest, Title } from './TootipSearchContent.styled';
import CloseButton from 'components/buttons/CloseButton';
import { hideAll } from 'tippy.js';
import { useFeatureFlags } from '@hooks/LaunchDarkly/useFeatureFlags';

function TootipSearchContent() {
	const { globalization, naturalLanguage }: any = useContext(CruiseSearchContext);
	const { setValueSearch } = naturalLanguage || {};
	const { dictionaries = {} } = globalization || {};
	const { generalDictionary = {} } = dictionaries || {};
	const { labelNLSTooltipTitle = '', labelNLSTooltipDescription = '' } = generalDictionary;
	const { enableNaturalLanguageSearchVariations } = useFeatureFlags();
	const [suggestText] = enableNaturalLanguageSearchVariations;
	const startTyping = () => {
		setValueSearch(suggestText);
		hideAll();
	};

	useEffect(() => {
		const input = document.getElementById(':r0:');
		const handleFocus = () => {
			hideAll();
			input?.removeEventListener('focus', handleFocus);
		};
		input?.addEventListener('focus', handleFocus);
		return () => {
			input?.removeEventListener('focus', handleFocus);
		};
	}, []);

	return (
		<Container id="nl-search-tooltip">
			<CloseButton
				onClick={(e) => {
					e.stopPropagation();
					hideAll();
				}}
			/>
			<Title>{labelNLSTooltipTitle}</Title>
			<Description>{labelNLSTooltipDescription}</Description>
			<Suggest onClick={startTyping}>{suggestText}</Suggest>
		</Container>
	);
}

export default TootipSearchContent;
